import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";

import AffiliateExpedia from "../components/affiliate/AffiliateExpedia";
import AffiliateBooking from "../components/affiliate/AffiliateBooking";
import AffiliateTrip from "../components/affiliate/AffiliateTrip";
import AffiliateEconomyBooking from "../components/affiliate/AffiliateEconomyBooking";

import AffAmazon from "../components/affiliate/AffAmazon";
import AffEbay from "../components/AffEbay";

import FollowInstagram from "../components/FollowInstagram";
import FollowFacebook from "../components/FollowFacebook";

export default function ProgramasAfiliados() {
  const navigate = useNavigate();

  return (
    <>
      <Header />

      {/* ⭐ TOP BAR WITH CENTERED BUTTONS + SOCIAL ICONS BELOW */}
      <div
        style={{
          margin: "20px 0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "15px",
          padding: "0 20px",
        }}
      >
        {/* CENTER — BUTTONS */}
        <div style={{ display: "flex", gap: "15px" }}>
          <Link className="main-button" to="/">Go Back</Link>

          <button
            className="main-button"
            onClick={() => navigate("/map/usa")}
          >
            USA Map
          </button>
        </div>

        {/* SOCIAL ICONS — CENTERED UNDER BUTTONS */}
        <div style={{ display: "flex", gap: "10px" }}>
          <FollowFacebook />
          <FollowInstagram />
        </div>
      </div>

      <div className="affiliate-container">
        {/* Travel Section */}
        <div className="affiliate-travel">
          <h3 style={{ textAlign: "center" }}>
            If you are looking for a place to stay, you can check prices, date
            and time here.
          </h3>

          <div className="affiliate-block">
            <AffiliateExpedia />
            <AffiliateBooking />
            <AffiliateTrip />
            <AffiliateEconomyBooking />
          </div>
        </div>

        {/* Gear Section */}
        <div
          className="affiliate-block"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <h3 style={{ textAlign: "center" }}>
            Find all the gear you need for your next adventure.
          </h3>

          <div style={{ width: "250px" }}>
            <AffAmazon />
          </div>

          <div style={{ width: "250px" }}>
            <AffEbay />
          </div>
        </div>
      </div>
    </>
  );
}
